<template>
  <v-bottom-sheet
    id="embedded-botton"
    v-model="sheet"
    hide-overlay
    width="350px"
    persistent
    scrollable
    round
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="embedded"
        fab
        dark
        large
        color="#00a7e4"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon dark> mdi-phone-outgoing </v-icon>
      </v-btn>
      <!-- <v-btn color="#00a7e4" icon size="large" dark fab v-bind="attrs" v-on="on" class="embedded">
                <v-icon color="#00a7e4" dark>                   
                     mdi-phone-outgoing 
                </v-icon>
            </v-btn> -->
    </template>

    <v-sheet
      height="420px"
      color="#00a7e4"
      class="pl-2 pr-2"
      style="border-radius: 6px"
      flat
    >
      <v-card height="410" class="" round flat>
        <v-toolbar flat color="#00a7e4" dark>
          <v-toolbar-title class="text-center">Call it Once</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="sheet = !sheet">
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </v-toolbar>
        <v-row
          v-show="this.$route.query.llamadaMasiva !== 'true'"
          class="mt-5"
          justify="center"
        >
          <v-col cols="11">
            <v-select
              label="Campañas"
              color="#00a7e4"
              outlined
              clearable
              :items="campaingsSelected"
              hide-details
              dense
              v-model="type_campaing"
              item-value="id"
              :disabled="this.llamar !== false"
            >
              <template v-slot:item="{ item }">
                <div>
                  <strong>{{ formatText(item) }}</strong>
                </div>
              </template>
              <template v-slot:selection="{ item }">
                <span style="font-size: 11px">
                  {{ formatText(item) }}
                </span>
              </template>
            </v-select>
          </v-col>
        </v-row>
        <v-card-text
          v-if="
            type_campaing != null || this.$route.query.llamadaMasiva == 'true'
          "
        >
          <v-row class="mt-1 mr-5" justify="space-around">
            <v-col cols="1">
              <v-btn
                id="botton-call"
                fab
                small
                color="success"
                @click="callNumber"
                :disabled="llamar || this.selectPhone == null"
              >
                <v-icon dark>mdi-phone</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="1" v-if="showHangUpConference">
              <v-btn
                fab
                small
                color="red"
                @click="stopConference"
                :disabled="!showHangUpConference"
              >
                <v-icon color="white">mdi-phone-hangup</v-icon>
              </v-btn>
            </v-col>

            <v-col cols="1" v-if="dispoLabel != 'Validacion Pago'">
              <v-btn
                fab
                small
                color="red"
                @click="stopCall"
                :disabled="!colgar"
              >
                <v-icon color="white">mdi-phone-hangup</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="1" v-else>
              <v-btn fab small color="blue" @click="validadorFlujo">
                <v-icon color="white">mdi-phone-forward</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <v-form ref="formDisposicion">
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  label="Tipos de contacto"
                  color="#00a7e4"
                  outlined
                  clearable
                  :items="TiposContactos"
                  hide-details
                  dense
                  v-model="tipo_contacto"
                  :rules="[$rules.required]"
                  :disabled="!llamar"
                >
                </v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  label="Disposición"
                  clearable
                  color="#00a7e4"
                  outlined
                  :items="disposicionesAux"
                  hide-details
                  dense
                  v-model="disposicion"
                  :disabled="tipo_contacto == null"
                  item-text="disposicion"
                  item-value="id"
                  :rules="[$rules.required]"
                >
                </v-autocomplete>
              </v-col>
            </v-row>

            <v-row class="mt-2 mr-4" justify="space-around" align="center">
              <v-col cols="1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon dark x-large>mdi-calendar-month</v-icon>
                    </v-btn>
                  </template>
                  <span>Agendar llamada</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row v-if="registrarAgenda">
              <v-col cols="12">
                <v-text-field
                  v-model="dateAgenda"
                  label="Fecha de agenda"
                  type="datetime-local"
                  hide-details
                  color="#00a7e4"
                  outlined
                  :rules="[$rules.required]"
                >
                  <template #prepend>
                    <v-btn icon @click="cancelAgenda">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <!-- <template v-if="isSolicitud">
          <v-card-actions class="ml-2 dd-flex justify-center text-center">
            <v-btn
              dark
              color="primary"
              @click="openModal"
              small
              :disabled="validarLead"
            >
              Crear solicitud
            </v-btn>
          </v-card-actions>
        </template> -->
        <template v-if="isVenta">
          <v-card-actions class="ml-2 dd-flex justify-center text-center">
            <v-btn
              v-if="
                roles == 'AGENTCC' ||
                roles == 'AGENTCCSPONSORS' ||
                roles == 'OPERADOR' ||
                roles == 'OPERADORCC' ||
                roles == 'ADMIN' ||
                roles == 'RENOVACIONESCC'
              "
              dark
              color="primary"
              @click="openPolizaModal"
              small
              :disabled="validarLead"
            >
              Crear Póliza
            </v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-sheet>
    <LoadingValidador :dialog="dialogValidador" />
    <CommonActionModal
      :dialog="foundValidador"
      :title="titlevalidador"
      :subtitle="subtitlevalidador"
      :bottonText="'Enlazar llamada'"
      @userChoice="goToValidadorSeleccionado"
      @closeModal="foundValidador = false"
    />
    <CommonActionModal
      :dialog="noTfoundValidadorDialog"
      title="Validador no disponible"
      subtitle="En breve un validador tomará la llamada 🙌 Te pedimos mantener al cliente en espera un momento mientras se libera uno."
      bottonText="Esperar"
      :onlyOneButton="true"
      @userChoice="
        () => {
          noTfoundValidadorDialog = false;
        }
      "
      @closeModal="noTfoundValidadorDialog = false"
    />
    <CommonActionModal
      :dialog="foundValidadorDialog"
      title="llamada trasferida"
      subtitle="La llamada fue trasferida al Validador y se ha finalizado su llamada"
      bottonText="Aceptar"
      :onlyOneButton="true"
      @userChoice="
        () => {
          foundValidadorDialog = false;
        }
      "
      @closeModal="foundValidadorDialog = false"
    />
  </v-bottom-sheet>
</template>

<script>
import { loadScript } from "vue-plugin-load-script";
import { mainAxios } from "@/mainAxios.js";
var moment = require("moment-timezone");
import { updatePrimerLlamada } from "@/services/leads/leads.service";
//import Incoming from "~/assets/phone-incoming-outgoing.svg";
import { getDisposicionesByOrigenID } from "@/services/campaings/campaing.service";
import { getValidadoresList } from "@/services/validador/validador.service";
import LoadingValidador from "@/components/commonComponents/LoadingValidador.vue";
import CommonActionModal from "@/components/commonComponents/CommonActionModal.vue";
import { updateValidadorEstatus } from "@/services/leads/leads.service";
import { getAgenteById } from "@/services/user/user.service";

export default {
  name: "Embedded",
  components: { LoadingValidador, CommonActionModal },
  props: {
    leadOrigen: {
      type: Object,
      require: false,
      default: () => [],
    },
    lead: {
      type: Object,
      require: true,
    },
    campaings: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialog: false,
      isSolicitud: false, // verifico si la disposicion es solicitud
      isVenta: false, // verifico si la disposicion es Venta
      registrarAgenda: false, // registra la llamada para una agenda
      isConference: false,
      loading: false,
      loadingBotton: false,
      sendMessage: false, // active if send global_id from poliza
      // icon
      // icon: Incoming,
      // listas variable
      TiposContactos: ["Contacto Efectivo", "Contacto no efectivo"],
      disposiciones: [],
      disposicionesAux: [],
      polizas: [], // lista de las polizas
      // config dialog embedded // pasar en otro archivo secundario
      sheet: false,
      llamar: false,
      colgar: false,
      mute: false,
      callInfo: null,

      // var user
      calendar: false,
      dateFormatted: null,

      // var to agend call
      dateAgenda: null,
      ListNumber: [],
      selectPhone: null,

      // disposicion
      tipo_contacto: null,
      disposicion: null,
      poliza: null,
      global_id: null,
      is_emitido: false,
      servicio_embebido: "",
      roles: JSON.parse(localStorage.getItem("roles"))[0].rol,
      fechaPrimerLlamada: "",
      type_campaing: null,
      dialogValidador: false,
      foundValidador: false,
      validadorSeleccionado: {},
      withoutValidador: false,
      noTfoundValidadorDialog: false,
      showHangUpConference: false,
      foundValidadorDialog: false,
    };
  },
  async mounted() {
    this.getDisposiciones();
    if (this.$route.query.llamadaMasiva == "true") {
      this.setCallData();
      this.getDisposiciones();
      this.actualizarLead();
    }
    loadScript(
      "https://aligev55.zw-callitonce.alestra.net.mx/agentdesktop/libs/servicepattern-sdk-v1.js"
    )
      .then(() => {
        window.bpspat.api.init("https://aligev55.zw-callitonce.alestra.net.mx");
      })
      .catch(() => {
        console.error(
          "Fallo al carga el sdk, Refresque la pagina para realizar la llamada"
        );
      });
    setTimeout(() => this.checkStatus(), 2000);
  },
  watch: {
    tipo_contacto(val) {
      if (val == null) {
        this.colgar = false;
        this.disposicion = null;
      }
      this.filteDisposicion();
    },
    disposicion(val) {
      const disposicionFound = this.disposiciones.find((e) => e.id == val);
      const esVenta =
        disposicionFound && disposicionFound.disposicion == "Venta";

      const agendarLlamada =
        disposicionFound &&
        disposicionFound.disposicion.includes("Agendar Llamada");
      const esSolicitud =
        disposicionFound && disposicionFound.disposicion.includes("Solicitud");

      if (esVenta) {
        if (
          this.leadOrigen.medio != "coche seguro inter.mx" &&
          this.leadOrigen.medio != "Growth seguro coche"
        ) {
          this.isVenta = true;
          this.isSolicitud = false;
          this.checarLeadIncomplete();
        }
      }
      if (esSolicitud) {
        this.isSolicitud = true;
        this.isVenta = false;
        this.checarLeadIncomplete();
      } else {
        this.isSolicitud = false;
      }
      if (agendarLlamada) {
        this.registrarAgenda = true;
      } else {
        this.registrarAgenda = false;
        this.dateAgenda = null;
      }
      if (val != null || val == "") {
        this.colgar = true;
      } else {
        this.colgar = false;
      }
    },
    dateAgenda() {
      this.dateFormatted = this.formatDate(this.dateAgenda);
    },
    lead() {
      this.checarLeadIncomplete();
    },
    llamar(val) {
      if (val) this.fechaPrimerLlamada = moment().format("YYYY-MM-DD HH:mm:ss");
    },
    type_campaing() {
      this.setCallData();
      this.getDisposiciones();
    },
  },

  methods: {
    cancelAgenda() {
      this.tipo_contacto = null;
      this.disposicion = null;
      this.registrarAgenda = false;
    },
    setCallData() {
      if (this.$route.query.llamadaMasiva == "true") {
        this.selectPhone = this.leadOrigen.telefono;
        this.servicio_embebido = this.leadOrigen.servicio_embebido;
      } else {
        var currentCampaing = this.campaingsSelected.find((e) => {
          return e.id == this.type_campaing;
        });
        this.selectPhone = currentCampaing.telefono;
        this.servicio_embebido = currentCampaing.servicio_embebido;
      }
    },
    formatDate(date) {
      if (!date) {
        this.colgar = false;
        return null;
      }
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    async getDisposiciones() {
      let id =
        this.$route.query.llamadaMasiva == "true"
          ? this.leadOrigen.id
          : this.type_campaing;
      const result = await getDisposicionesByOrigenID(id);
      console.log(result);
      result.map((element) => {
        this.disposiciones.push({
          id: element.id,
          disposicion: element.disposicion,
          tipo_contacto: element.tipoContacto,
        });
      });
    },
    saveDisposition(esParaValidador = false) {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      const disposicionName = this.disposicionesAux.filter(
        (item) => item.id == this.disposicion
      );
      let current_lead =
        this.$route.query.llamadaMasiva == "true"
          ? this.leadOrigen
          : this.currentSelect;

      const request = {
        leadUuid: current_lead.uuid_lead_segurify,
        origen_uuid: current_lead.uuid,
        disposicion: disposicionName[0].disposicion,
        codigo_disposicion: String(this.disposicion),
        fecha_agenda: this.dateAgenda
          ? moment.utc(this.dateAgenda).format("YYYY-MM-DD HH:mm:ss")
          : null,
        tipo_llamada: "Outbound",
        globalInteractionId: this.globalId,
        fechaPrimerLlamada: true,
        callback: 0,
        marcacion_automatica:
          this.$route.query.llamadaMasiva === "true" ?? false,
        agendaValidador: false,
      };

      mainAxios
        .post("/v1/accion/lead-segurify/crear", request, config)
        .then(() => {
          this.$emit("getLlamadas");
          if (esParaValidador) this.startConference();
          else this.$emit("isAlreadySeended");
          this.tipo_contacto = null;
          this.disposicion = null;
        });
    },
    filteDisposicion() {
      this.disposicionesAux = this.disposiciones.filter(
        (item) => item.tipo_contacto == this.tipo_contacto
      );
    },
    callNumber() {
      this.llamar = true;
      window.bpspat.api.selectService(this.servicio_embebido);
      //this.selectPhone = '4492344656';
      window.bpspat.api.dialNumber(this.selectPhone);
      window.bpspat.api.addInteractionRenderedHandler(this.logs);
    },
    stopCall() {
      window.bpspat.api.getState(({ data }) => {
        let ivr = data.interactions.find((item) => item.phone_number == 4545);
        if (ivr) {
          window.bpspat.api.completeInteractionWithDisp(
            ivr.item_id,
            String("99999999")
          );
        }
        let interaccion = data.interactions.find(
          (item) => item.phone_number == this.selectPhone
        );
        window.bpspat.api.completeInteractionWithDisp(
          interaccion.item_id,
          String("99999999")
        ); // se termina la llamada con el envio de la disposicion
      });
      //Aqui guardamos todo para cuando se cuelga
      this.colgar = false;
      this.llamar = false;
      this.saveDisposition();
      this.sheet = !this.sheet;
    },
    openModal() {
      this.$emit("openSolicitudModal");
    },
    openPolizaModal() {
      this.$emit("openPolizasModal");
    },
    logs(state) {
      this.globalId = state.data.global_id;
      this.myItemId = state.data.item_id;
    },
    statusChecked(state) {
      this.$emit("successEmbedded", state);
      if (this.$route.query.llamadaMasiva === "true") {
        const btn_embedded = document.getElementsByClassName(
          "embedded v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--large"
        );
        btn_embedded[0].click();
        if (this.$route.query.automatic_Call !== "false") {
          this.callNumber();
          //this.postActualizacionMomentaneo();
        }
      }
    },
    checkStatus() {
      window.bpspat.api.getState(this.statusChecked);
    },
    checarLeadIncomplete() {
      if (
        typeof this.lead.medio != "undefined" &&
        typeof this.lead.producto != "undefined" &&
        typeof this.lead.regimen != "undefined" &&
        typeof this.lead.rfc != "undefined" &&
        typeof this.lead.nombre != "undefined" &&
        typeof this.lead.apellidoPaterno != "undefined" &&
        typeof this.lead.apellidoMaterno != "undefined" &&
        typeof this.lead.fechaNacimiento != "undefined" &&
        typeof this.lead.sexo != "undefined" &&
        typeof this.lead.estadoCivil != "undefined" &&
        typeof this.lead.edad != "undefined" &&
        typeof this.lead.telefono != "undefined" &&
        typeof this.lead.correo != "undefined" &&
        typeof this.lead.calle != "undefined" &&
        typeof this.lead.num_exterior != "undefined" &&
        typeof this.lead.num_interior != "undefined" &&
        typeof this.lead.codigoPostal != "undefined" &&
        typeof this.lead.colonia != "undefined" &&
        typeof this.lead.ciudad != "undefined" &&
        typeof this.lead.estado != "undefined" &&
        typeof this.lead.pais != "undefined"
      ) {
        this.validarLead = false;
      } else {
        this.$emit("leadIncomplete");
        this.validarLead = true;
      }
    },
    async actualizarLead() {
      await updatePrimerLlamada(this.$route.query.origenLeadUuid);
    },
    formatText(item) {
      return `${item.medio} - ${moment
        .utc(item.fecha_lead)
        .subtract(6, "hours")
        .format("DD/MM/YYYY HH:mm:ss")}`;
    },
    async validadorFlujo() {
      this.dialogValidador = true;
      try {
        let response = await getValidadoresList();
        if (response.total > 0) {
          this.validadorSeleccionado = this.getRandomRecord(response.data);
          this.foundValidador = true;
        } else {
          this.withoutValidador = true;
          this.noTfoundValidadorDialog = true;
        }
        this.dialogValidador = false;
      } catch {
        this.dialogValidador = false;
      }
    },
    getRandomRecord(array) {
      if (!array || array.length === 0) {
        return null;
      }
      const randomIndex = Math.floor(Math.random() * array.length);
      return array[randomIndex];
    },
    async goToValidadorSeleccionado(opt) {
      if (!opt) {
        this.foundValidador = false;
      } else {
        this.foundValidador = false;
        this.valio;
        if (this.validadorSeleccionado.extension) this.saveDisposition(true);
        else {
          let resp = await this.getAgenteById(this.validadorSeleccionado.id);
          if (resp.extension) {
            this.validadorSeleccionado.extension = resp.extension;
            this.saveDisposition(true);
          }
        }
      }
    },
    async updateValidadorEstatus(validadorId) {
      return await updateValidadorEstatus(
        this.$route.query.origenLeadUuid,
        validadorId
      );
    },
    stopConference() {
      window.bpspat.api.getState(({ data }) => {
        let ivr = data.interactions.find((item) => item.phone_number == 4545);
        if (ivr) {
          window.bpspat.api.completeInteractionWithDisp(
            ivr.item_id,
            String("99999999")
          );
        }
        let interaccion = data.interactions.find(
          (item) => item.phone_number == this.leadOrigen.telefono
        );
        window.bpspat.api.completeInteractionWithDisp(
          interaccion.item_id,
          String("99999999")
        ); // se termina la llamada con el envio de la disposicion
      });
      //Aqui guardamos todo para cuando se cuelga
      this.colgar = false;
      this.llamar = false;
      this.saveDisposition();
      this.sheet = !this.sheet;
    },
    async startConference() {
      this.foundValidadorDialog = true;
      try {
        await this.updateValidadorEstatus(this.validadorSeleccionado.id);
        window.bpspat.api.singleStepTransfer(
          this.validadorSeleccionado.extension.toString()
        );
      } catch (error) {
        console.error(error);
      }
    },
    async getAgenteById(id) {
      try {
        return await getAgenteById(id);
      } catch (error) {
        this.$toast.error(
          "Error al traer el validador transferencia cancelada"
        );
      }
    },
  },
  computed: {
    campaingsSelected() {
      if (this.campaings.length > 0) return this.campaings;
      else return [];
    },
    currentSelect() {
      if (this.type_campaing)
        return this.campaingsSelected.find((e) => {
          return e.id == this.type_campaing;
        });
      else return {};
    },
    dispoLabel() {
      if (!this.disposicion) return "";
      const dispo = this.disposicionesAux.find((e) => e.id == this.disposicion);
      return dispo ? dispo.disposicion : "";
    },
    titlevalidador() {
      return "Validador encontrado";
    },
    subtitlevalidador() {
      return `La llamada cambiara a tranferencia con el validador: ${
        this.validadorSeleccionado
          ? this.validadorSeleccionado.nombreCompleto
          : ""
      }`;
    },
  },
};
</script>

<style scoped>
.embedded {
  position: fixed;
  bottom: 160px;
  right: 0;
}
.v-dialog__content {
  justify-content: end !important;
}
</style>
